import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import GoToCCMarketplaceButton from 'components/GoToCCMarketplaceButton/GoToCCMarketplaceButton';
import StandardEngagementOffers from 'components/Offers/StandardEngagementOffers/StandardEngagementOffers';
import Label from 'components/form/Label/Label';

import StaticOfferContainer from 'partial/OfferManager/StaticOfferContainer';

const EngagementOffersModuleView = props => {
  const {
    eventHandler,
    additionalData,
    onClickSeeMore,
    offers,
    seenModuleTracking,
    sendPutEvenTypeFromOfferModule,
    modulePosition,
    moduleName,
  } = props;
  return (
    <>
      <FlexContainer className={'flex-column gap-16'}>
        <FlexContainer className={'flex-column'}>
          {seenModuleTracking}
          <FlexContainer
            className={'justify-between align-center align-baseline'}
          >
            <Label
              type="H4Half"
              typeHeader={'h2'}
              className={'text-20 m-text-18'}
            >
              {additionalData?.eventInfo?.titleText
                ? additionalData?.eventInfo?.titleText
                : additionalData?.titleText}
            </Label>
          </FlexContainer>
        </FlexContainer>
        <FlexContainer className={'m-hide bgWhite border-rad8px grayShadow16'}>
          <StaticOfferContainer
            offerMetadataList={offers?.slice(0, 2)}
            creditCardTemplate={StandardEngagementOffers}
            datatestid={'engagement-offers'}
            eventHandler={eventHandler}
            pagePosition={moduleName}
            sendPutEvenTypeFromOfferModule={sendPutEvenTypeFromOfferModule}
            modulePosition={modulePosition}
          />
          <FlexContainer className={'flex-1 align-items-center'}>
            <GoToCCMarketplaceButton
              onClickHandler={onClickSeeMore}
              showDesktop
              fullWidth
            />
          </FlexContainer>
        </FlexContainer>
        <FlexContainer
          className={'d-hide flex-column bgWhite border-rad8px grayShadow16'}
        >
          <StaticOfferContainer
            offerMetadataList={offers?.slice(0, 4)}
            creditCardTemplate={StandardEngagementOffers}
            datatestid={'engagement-offers'}
            eventHandler={eventHandler}
            pagePosition={moduleName}
            sendPutEvenTypeFromOfferModule={sendPutEvenTypeFromOfferModule}
            modulePosition={modulePosition}
          />
          <FlexContainer className={'flex-column padTB16 padLR50 d-hide'}>
            <GoToCCMarketplaceButton onClickHandler={onClickSeeMore} />
          </FlexContainer>
        </FlexContainer>
      </FlexContainer>
    </>
  );
};

export default EngagementOffersModuleView;
